import React, { useEffect } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from '../hooks/useAuthState';

const ADMIN_UIDS = new Set([
  'mvYUkkB4A8Tr6NwmIzulG7pSvnr2',
  'cwYcCKc9yNNTmUce7BFUkLMcteu1',
]);

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, loading } = useAuthState();

  useEffect(() => {
    if (!loading && user && ADMIN_UIDS.has(user.uid)) navigate('/admin', { replace: true });
  }, [user, loading, navigate]);

  async function handleLogin() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      if (!ADMIN_UIDS.has(result.user.uid)) {
        await auth.signOut();
        alert('Access denied. This portal is for Cura admins only.');
      }
    } catch (e) {
      if (e.code !== 'auth/popup-closed-by-user') alert('Sign-in failed. Please try again.');
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="20" fill="var(--green-800)" />
            <path d="M20 10c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 16a6 6 0 110-12 6 6 0 010 12z" fill="white" opacity="0.9"/>
            <circle cx="20" cy="20" r="3" fill="white"/>
          </svg>
        </div>
        <h1 style={styles.title}>Cura Admin</h1>
        <p style={styles.subtitle}>Sign in to access the feedback dashboard</p>
        <button style={styles.btn} onClick={handleLogin}>
          <svg width="20" height="20" viewBox="0 0 24 24" style={{ marginRight: 10 }}>
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  card: {
    background: 'white',
    borderRadius: 'var(--radius-lg)',
    padding: '48px 40px',
    boxShadow: 'var(--shadow-lg)',
    textAlign: 'center',
    maxWidth: 400,
    width: '100%',
  },
  logo: { marginBottom: 20 },
  title: { fontSize: 28, fontWeight: 800, color: 'var(--green-900)', marginBottom: 8 },
  subtitle: { color: 'var(--text-secondary)', fontSize: 15, marginBottom: 36, lineHeight: 1.5 },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '14px 24px',
    background: 'white',
    border: '1.5px solid var(--border)',
    borderRadius: 'var(--radius-sm)',
    fontSize: 15,
    fontWeight: 600,
    color: 'var(--text-primary)',
    boxShadow: 'var(--shadow-sm)',
    transition: 'box-shadow 0.2s',
  },
};
